import React from 'react';
import { Content } from 'src/common/interfaces/content.interface';
import { DocumentViewer } from './document-viewer';
import { DocumentViewerEmpty } from './document-viewer-empty';

export const DocumentViewerFactory = ({ document }: Content) => {
  if (!document) {
    return () => null;
  }

  const ViewerComponent = document.blocks.length === 0 ? DocumentViewerEmpty : DocumentViewer;

  return () => <ViewerComponent document={document} containerClassName='!p-0' className='!p-0' />;
};
